import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRecordWorkflow = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} viewBox="0 0 24 24" {...props}>
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.75}
            d="m3 15 7 2.7-3 1.1-1.1 3zM18 1.8l1.47 2.73L22.2 6l-2.73 1.47L18 10.2l-1.47-2.73L13.8 6l2.73-1.47z"
        />
        <path
            fill="none"
            stroke="currentColor"
            strokeDasharray="0 3.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.75}
            d="M4 11.5c0-5 4.5-6 9-5.5"
        />
    </svg>
);
export default SvgRecordWorkflow;
